import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IdNowComponent } from './id-now.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';



@NgModule({
  declarations: [
    IdNowComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule
  ]
})
export class IdNowModule { }
